export default {
  pt: {
    pageTitle: "Dados do segurado",
    mainTitle: "Informações do segurado",
    description: "A seguradora irá considerar os dados informados. Se o segurado for menor de 18 anos, favor informar os dados do representante legal.",
    nameLabel: "Nome Completo",
    phoneLabel: "Celular",
    emailLabel: "E-mail",
    nameRequired: "Nome é obrigatório",
    nameMinLength: "Nome deve ter ao menos 3 caracteres",
    nameMinWords: "Pelo menos 2 nomes com no mínimo 3 caracteres",
    nameMinWordLength: "Nome deve ter no mínimo 3 caracteres",
    emailRequired: "E-mail é obrigatório",
    emailInvalid: "E-mail inválido",
    phoneRequired: "Celular é obrigatório",
    phoneInvalid: "Celular inválido",
  },

  en: {
    pageTitle: "Insured data",
    mainTitle: "Insured information",
    description: "The insurer will consider the provided data. If the insured is under 18 years old, please provide the legal representative's data.",
    nameLabel: "Full Name",
    phoneLabel: "Mobile",
    emailLabel: "E-mail",
    nameRequired: "Name is required",
    nameMinLength: "Name must have at least 3 characters",
    nameMinWords: "At least 2 names with minimum 3 characters",
    nameMinWordLength: "Name must have minimum 3 characters",
    emailRequired: "E-mail is required",
    emailInvalid: "Invalid e-mail",
    phoneRequired: "Mobile is required",
    phoneInvalid: "Invalid mobile",
  },
}; 